var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle-box text-center animated fadeInDown"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h3',{staticClass:"font-bold"},[_vm._v("Página não encontrada")]),_vm._v(" "),_c('p',{staticClass:"error-desc"},[_vm._v("\n    Desculpe, mas a página que você está procurando foi não encontrada.\n  ")])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ee7c92","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/404/componentes/PaginaNaoEncontrada.vue
// module id = 1885
// module chunks = 0